import instance from './Api';

export default class ExtraService {

    iniciarConteudoExtra(code, codigoAtividade, callback) {
        instance.post(this.host() + '/api/v1/campaign/schedule/' + code + '/activity/' + codigoAtividade)
            .then((response) => {
                callback(null, response.data)
            })
            .catch((error) => {
                callback(error, null)
            })
    }

    host() {
        return process.env.REACT_APP_HOST_API
    }

}